export default {
  ShortDay: 'MMMM DD',
  Time: 'h:mma',
  FullDay: 'MM/DD/yyyy',
  VerboseDay: 'dddd, MMMM Do YYYY, h:mm a',
  SimpleTime: 'MMMM Do, h:mm a',
  FullTime: 'h:mm:ssa',
  LongDay: 'MMMM Do, YYYY',

  DaysOfTheWeek: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
  },
};
